import React, { useContext, useState } from 'react'
import { Box, Text } from '../../../designSystem'
import { emailContentGenerator } from '../../../lib/utils'
import { AccountContext } from '../../../providers/accountProvider'
import {
  promotional_text_approved,
  promotional_text_published,
  promotional_text_updated,
} from '../constants'
import { descriptionCard, descriptionText, MailLink } from '../style'
import RevenueShareVideoPopup from './revenueShareVideoPopup'
import { ClickHereText } from './styles'

function CautionNote({
  bookDetails,
  isNonIndianAndNonUSUser,
  signingStatus,
  history,
  viewApplication
}) {
  const [videoPopup, setVideoPopup] = useState(false)
  const { user } = useContext(AccountContext)
  const isUSUser =
    bookDetails?.is_novel === 2 ||
    bookDetails?.program_type === 'writer_benefit_v3_us'
  const isPublished =
    bookDetails?.status === 'published' || bookDetails?.status === 'approved'
  const eligibleForIncentive = !!bookDetails?.eligible_for_incentive
  const isNotApplied = bookDetails?.application_status === 'not_applied'
  const isCreated = bookDetails?.application_status === 'created'
  const isEligible = bookDetails?.application_status === 'eligible'
  const isPending = bookDetails?.application_status === 'pending'
  const isRejected = bookDetails?.application_status === 'rejected'
  const isTerminated = bookDetails?.application_status === 'termination'
  const isCompleted = bookDetails?.application_status === 'completion'
  const isUpdated = bookDetails?.application_status === 'updated'
  const isApproved = bookDetails?.application_status === 'approved'
  const isReapplied = bookDetails?.application_status === 'reapplied'
  const isDisabled = bookDetails?.status === 'disabled'
  const publishTime = bookDetails?.publish_time
  const isDraft = bookDetails?.status === 'draft'
  const unPublishedByCMS = isDraft && publishTime
  const isMobile = window.screen.width < 600
  const mailContentForFlaggedBook = emailContentGenerator(
    user,
    bookDetails.book_id,
    'Query/Compliant against flagged content',
    'Kindly write your detailed query/complaint below and attach proof of original fiction if falsely flagged by us.'
  )
  const mailContentForDisableBook = emailContentGenerator(
    user,
    bookDetails.book_id,
    'Query/Compliant against disabled content',
    'Kindly write your detailed query/compliant below and attach proof of original fiction if falsely disabled by us.'
  )
  const flaggedText =bookDetails?.is_novel === 2 ? (
    <>
      This 🎧 series has been flagged due to unusual behavior on request from readers, 
      Please note we only support books with non-sensitive original & fiction content
      with a proper storyline. If any concerns, please reach out to us at 
      <MailLink href={mailContentForDisableBook}>
        {' '}writers@pocketfm.com
      </MailLink>
    </>
  ) : (
    <>
      {' '}
      This book has been flagged due to unusual behavior on request from
      readers, Please note we only support books with non-sensitive original &
      fiction content with a proper storyline.
      <br /> If any concerns, please reach out to us at{' '}
      <MailLink href={mailContentForFlaggedBook}>
        writers@pocketfm.com
      </MailLink>{' '}
      .
    </>
  )

  const disabledText = bookDetails?.is_novel === 2 ? (
    <>
      This 🎧 series has been disabled on request from the author or
      readers. Please note we only support books with non-sensitive
      original & fiction content with a proper storyline. 
      If any concerns, please reach out to us at 
      <MailLink href={mailContentForDisableBook}>
        {' '}writers@pocketfm.com
      </MailLink>
    </>
  ) : (
    <>
      This book has been disabled on request from the author or
      readers. Please note we only support books with non-sensitive
      original & fiction content with a proper storyline. If any
      concerns, please reach out to us at{' '}
      <MailLink href={mailContentForDisableBook}>
        writers@pocketfm.com
      </MailLink>{' '}
      . Repeat strikes could lead to the account being blocked.
    </>
  )

  const analyticsPageRedirectHTML = () => (
    <span
      style={{ color: 'blue', cursor: 'pointer' }}
      onClick={() => history.push(`/analytics?bookId=${bookDetails.book_id}`)}
    >
      here
    </span>
  )

  return (
    <>
      <RevenueShareVideoPopup
        videoPopup={videoPopup}
        setVideoPopup={setVideoPopup}
      />
      {/* incentive eligible books */}
      {eligibleForIncentive && (
        <Box {...descriptionCard}>
          {/* Non Ongoing Books */}
          {bookDetails?.application_status !== 'ongoing' && (
            <Text {...descriptionText}>
              {isDraft && (
                <strong>
                  Publish atleast 1 chapter to get it live on Pocket Novels app
                </strong>
              )}
              {isCreated && isPublished && (
                <>
                  Congratulations on publishing your {bookDetails?.is_novel === 2 ? 'series' : 'novel'}. Write 30000 words to
                  submit contract details & start receiving the generated
                  incentives
                </>
              )}
              {isEligible && (
                <>
                  Almost there, Submit contract details to start receiving the
                  generated incentives
                </>
              )}
              {isPending && signingStatus === 'applied' && (
                <>
                  Thank you for submitting your details .{' '}
                  <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() =>
                      history.push(
                        `shows/novels/id/${bookDetails.book_id}?tab=draft`
                      )
                    }
                  >
                    Sign Contract
                  </span>{' '}
                  & start receiving the generated incentives.
                </>
              )}
              {isPending && (!signingStatus || signingStatus !== 'applied') && (
                <>
                  Contract process is in review. All incentives will be
                  transferred to you, by the 2nd week of subsequent Month
                  post-contract confirmation.
                </>
              )}
            </Text>
          )}

          {/* Ongoing Books */}
          {bookDetails?.application_status === 'ongoing' && (
            <Text {...descriptionText}>
              {!bookDetails?.day_zero_incentive_eligible && !isUSUser && (
                <>
                  Tip: We have noticed novels updating daily has 90% lesser
                  readers dropping off. Don't forget to Publish quality chapters
                  daily.
                </>
              )}
              {!bookDetails?.day_zero_incentive_eligible &&
                bookDetails?.sub_status !== 'open_for_withdrawal' && isUSUser && (
                <>
                    Contract process is in review. All incentives will be
                    transferred to you, by the 2nd week of subsequent Month
                    post-contract confirmation.
                </>
              )}
              {bookDetails?.day_zero_incentive_eligible &&
                bookDetails?.sub_status !== 'open_for_withdrawal' && (
                  <>
                    Contract process is in review. All incentives will be
                    transferred to you, by the 2nd week of subsequent Month
                    post-contract confirmation.
                  </>
                )}
              {
                bookDetails?.sub_status === 'open_for_withdrawal' && (
                  <>
                    Tip: We have noticed {bookDetails?.is_novel === 2 ? 'series' : 'novels'} updating daily has 90% lesser
                    readers dropping off. Don't forget to Publish quality
                    chapters daily.
                  </>
                )}
            </Text>
          )}
        </Box>
      )}

      {/* incentive not eligible books */}
      {!eligibleForIncentive && (
        <Box {...descriptionCard}>
          {/* Non Ongoing Books */}
          {bookDetails?.application_status !== 'ongoing' && (
            <Text {...descriptionText}>
              {isDisabled && <>{disabledText}</>}
              {unPublishedByCMS && <>{flaggedText}</>}
              {!isPublished && isNotApplied && !isDisabled && !publishTime && (
                <strong>
                  {bookDetails?.is_novel === 2
                    ? 'Publish atleast 1 chapter to get it live on Pocket fm '
                    : 'Publish atleast 1 chapter to get it live on Pocket Novels app'}
                </strong>
              )}
              {!isNonIndianAndNonUSUser &&
                isPublished &&
                isNotApplied &&
                !bookDetails.is_eligible && (
                  <>
                    Congratulations on publishing your{' '}
                    {bookDetails.is_novel === 2
                      ? 'series'
                      : 'novel'}
                    . Write{' '}
                    {bookDetails.application_threshold == 15000
                      ? '15,000'
                      : '30,000'}{' '}
                    words to apply for the Writer’s Benefit Program.
                  </>
                )}
              {!isNonIndianAndNonUSUser &&
                isPublished &&
                isNotApplied &&
                bookDetails.is_eligible && (
                  <>
                    <strong>
                      Congratulations on publishing your{' '}
                      {bookDetails.is_novel === 2
                        ? 'series'
                        : 'novel'}
                      .{' '}
                    </strong>
                    You’re now eligble to apply for the Writer’s Benefit Program.
                  </>
                )}
              {!isNonIndianAndNonUSUser &&
                isPublished &&
                isPending &&
                (bookDetails.word_count >=
                (bookDetails?.application_threshold || 30000) ? (
                  <>
                    Your application is under review. Meanwhile, keep adding
                    more chapters to get more readers which will help us
                    evaluate your {bookDetails?.is_novel === 2 ? 'series' : 'novel'} earliest. Please note: Only{' '}
                    <strong> Top 10% </strong> of the application gets selected
                    for the writer&apos;s benefits program & It might take us 1
                    month or more to process.
                    {isMobile && (
                      <Box
                        onClick={() => viewApplication(bookDetails.book_id)}
                        color="interactive.azure2"
                      >
                        VIEW YOUR APPLICATION
                      </Box>
                    )}
                  </>
                ) : (
                  <>
                    <strong>
                      Thank you for applying for wbp program, it will be
                      reviewed once you complete 30,000 Words .
                    </strong>
                  </>
                ))}
              {isRejected && (
                <>
                  Currently, we cannot sign your {bookDetails?.is_novel === 2 ? 'series' : 'novel'} as it doesn’t meet our
                  minimum performance guidelines or editorial feedback.
                  {bookDetails?.is_novel === 2 ? (
                    <>
                      You can start a new series, and again apply for the Writer
                      Benefits Program. All the best!
                    </>
                  ) : (
                    <>
                      {' '}
                      You can refer to your novel’s engagement data vs Novels in
                      the Program{' '}
                      <span
                        style={{ color: 'blue', cursor: 'pointer' }}
                        onClick={() =>
                          history.push(
                            `/analytics?bookId=${bookDetails.book_id}`
                          )
                        }
                      >
                        here
                      </span>
                      .
                    </>
                  )}
                </>
              )}
              {isPublished && isTerminated && (
                <>
                  Thank you for adding your book to the Writer Benefit Program,
                  We have decided to end the book from the writer benefit
                  program as the retention is not up to expectation. You can
                  refer to your novel’s engagement data vs Novels in the Program{' '}
                  <span
                    style={{ color: 'blue', cursor: 'pointer' }}
                    onClick={() =>
                      history.push(`/analytics?bookId=${bookDetails.book_id}`)
                    }
                  >
                    here
                  </span>{' '}
                  . We are eagerly waiting for your next {bookDetails?.is_novel === 2 ? 'series' : 'novel'}. Best Wishes.{' '}
                </>
              )}
              {isPublished && isCompleted && (
                <>
                  {bookDetails?.is_novel === 2
                    ? 'Thank you for successfully adding your book through the Writer Benefit Program, we are eagerly waiting for your next series.'
                    : 'Thank you for successfully adding your book through the Writer Benefit Program, we are eagerly waiting for your next novel.'}{' '}
                </>
              )}
              {isPublished && isUpdated && promotional_text_updated}
              {!isNonIndianAndNonUSUser && isPublished && isApproved && (
                <>
                  {' '}
                  {promotional_text_approved.replace(
                    '{{amount}}',
                    user?.author_visibility === 'india' ? 'Rs 5000' : '$300'
                  )}{' '}
                </>
              )}
              {!isNonIndianAndNonUSUser && isPublished && isReapplied && (
                <>
                  You can again apply to the Writer’s Benefit Program after
                  completing 100,000 words on the basis of editorial feedback
                </>
              )}
            </Text>
          )}
          {/* Ongoing Books */}
          {bookDetails?.application_status === 'ongoing' && (
            <Text {...descriptionText}>
              {bookDetails?.sub_status !== 'open_for_withdrawal' &&
                bookDetails?.language === 'hindi' && (
                  <>
                    While the Daily Update Bonus and other incentives are not
                    applicable at the moment due to the {bookDetails?.is_novel === 2 ? 'series' : `novel's`} current
                    engagement level , we have an amazing alternative for you!
                    You can still earn through our revenue share program after
                    signing the contract.{' '}
                    <ClickHereText onClick={() => setVideoPopup(true)}>
                      Click here
                    </ClickHereText>{' '}
                    for more details.
                  </>
                )}
              {bookDetails?.sub_status !== 'open_for_withdrawal' &&
                bookDetails?.language !== 'hindi' && (
                  <>
                    Contract process is in review. All rewards will be
                    transferred to you, by the 2nd week of subsequent Month
                    post-confirmation.
                  </>
                )}
              {bookDetails?.sub_status === 'open_for_withdrawal' &&
                bookDetails?.language === 'hindi' && (
                  <>
                    Daily update bonus is not applicable due to the novel's low
                    engagement level. You can refer to your novel’s engagement
                    data vs other Novels in the Program{' '}
                    {analyticsPageRedirectHTML()} . But we have an amazing
                    alternative for you! You can still earn through our revenue
                    share program if you continue to write the novel.{' '}
                    <ClickHereText onClick={() => setVideoPopup(true)}>
                      Click here
                    </ClickHereText>{' '}
                    for more details.
                  </>
                )}
              {bookDetails?.sub_status === 'open_for_withdrawal' &&
                bookDetails?.language !== 'hindi' && (
                  <>
                    We have stopped daily update bonus as this {bookDetails?.is_novel === 2 ? 'series' : 'novel'} has very
                    low retention, You can refer to your novel’s engagement data
                    vs Novels in the Program {analyticsPageRedirectHTML()} You
                    can still continue to earn via coins for the {bookDetails?.is_novel === 2 ? 'series' : 'novel'} !
                  </>
                )}
            </Text>
          )}
        </Box>
      )}
    </>
  )
}

export default CautionNote
